var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRealEstate = function SvgRealEstate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "real-estate_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#real-estate_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.587 0c8.907.456 14.326 10.238 9.747 18.054-4.52 7.72-15.669 7.912-20.452.348C-3.02 10.657 2.302.432 11.412 0h1.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.878 9.267 1.75-4.352c.168-.407.468-.515.696-.084l1.822 4.448 4.735.347c.444.06.552.312.24.648l-3.668 3.117 1.139 4.579c.083.432-.072.66-.516.468l-4.088-2.53-4.052 2.506c-.527.263-.66-.084-.527-.552l1.103-4.495-3.56-2.997c-.372-.312-.432-.636.131-.732l4.771-.36.024-.011Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "real-estate_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgRealEstate as ReactComponent };